module.exports = __webpack_public_path__ + "media/images/function_title_logo-187e46f9d1c8bbb89c24556f714b5e6d.svg";